/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
export default {
  "sitecoreApiKey": "{584FD054-6FD5-4E3F-8FD4-5F698355E25E}",
  "sitecoreApiHost": "https://#{racq.website.cd.form.hostname}",
  "jssAppName": "racqforms",
  "defaultLanguage": "en",
  "graphQLEndpointPath": "/api/racqforms",
  "graphQLEndpoint": "https://#{racq.website.cd.form.hostname}/api/racqforms?sc_apikey={584FD054-6FD5-4E3F-8FD4-5F698355E25E}"
};